import { render, staticRenderFns } from "./GroupSelectedButtons.vue?vue&type=template&id=5285c063&scoped=true&"
import script from "./GroupSelectedButtons.vue?vue&type=script&lang=js&"
export * from "./GroupSelectedButtons.vue?vue&type=script&lang=js&"
import style0 from "./GroupSelectedButtons.vue?vue&type=style&index=0&id=5285c063&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5285c063",
  null
  
)

export default component.exports